import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../../utils/logger';
import { findIndex } from '../../utils/lang';
var log = logFactory('splitio-engine:matcher');
function partOfMatcherContext(ruleAttr
/*: array */) /*: Function */
{
  return function partOfMatcher(runtimeAttr
  /*: array */) /*: boolean */
  {
    var _context, _context2;

    // To be part of the length should be minor or equal.
    var isPartOf = runtimeAttr.length <= ruleAttr.length;
    var _loop = function _loop(i) {
      // If the length says is possible, we iterate until we prove otherwise or we check all elements.
      if (findIndex(ruleAttr, function (e) {
        return e === runtimeAttr[i];
      }) < 0) isPartOf = false;
    };
    for (var i = 0; i < runtimeAttr.length && isPartOf; i++) {
      _loop(i);
    }
    log.debug(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "[partOfMatcher] ".concat(runtimeAttr, " is part of ")).call(_context2, ruleAttr, "? ")).call(_context, isPartOf));
    return isPartOf;
  };
}
export default partOfMatcherContext;